const Contact = () => {

    return(
        <h2>Contacto</h2>
    )
}

export default Contact